<template>
    <div class="ui vue simulator accordion" v-bind:class="variant">
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        variant: String
    },
    data() {
        return {
            current: null,
            items: [],
            promises: []
        }
    },
    mounted() {
        this.$el.addEventListener('toggle', event => this.onItemToggle(event))
    },
    methods: {
        onItemToggle(event) {
            event.stopPropagation()

            if (this.promises.length > 0) {
                return
            }

            this.toggle(event.detail.item)
        },
        activate(index) {
            if (index > 0 && index <= this.items.length) {
                this.toggle(this.items[index - 1], true)
            }
        },
        add(item) {
            this.items.push(item)

            item.index = this.items.length
        },
        remove(item) {
            this.items.splice(item.index - 1, 1)
            this.items.forEach((item, index) => item.index = index)

            if (this.current === item) {
                this.current = null
            }
        },
        async toggle(item, force) {
            item.$emit(
                'toggle',
                {
                    active: !item.active, 
                    waitUntil: (promise) => this.promises.push(promise)
                }
            )

            if (this.promises.length > 0) {
                item.loading = true

                await Promise.all(this.promises)
                this.promises.splice(0, this.promises.length)

                item.loading = false
            }

            if (this.current !== null && this.current !== item) {
                this.current.active = false
            }

            item.active = force !== undefined ? force : !item.active

            this.current = item.active ? item : null
        }
    }
}
</script>